// src/api/discovery.js
import { api } from './client';

// --- Candidates ---

export function getCandidates({ status, page = 1, perPage = 50 } = {}) {
  const params = { page, per_page: perPage };
  if (status) params.status = status;
  return api.get('/api/discovery/candidates', { params }).then(r => r.data);
}

export function approveCandidate(id, { reviewedBy, skuOverride = null, editTarget = null } = {}) {
  return api.post(`/api/discovery/candidates/${id}/approve`, {
    reviewed_by: reviewedBy,
    sku_override: skuOverride,
    edit_target: editTarget,
  }).then(r => r.data);
}

export function rejectCandidate(id, { reviewedBy, reason = '' } = {}) {
  return api.post(`/api/discovery/candidates/${id}/reject`, {
    reviewed_by: reviewedBy,
    reason,
  }).then(r => r.data);
}

export function deferCandidate(id, { reviewedBy } = {}) {
  return api.post(`/api/discovery/candidates/${id}/defer`, {
    reviewed_by: reviewedBy,
  }).then(r => r.data);
}

// --- Stats & Runs ---

export function getDiscoveryStats() {
  return api.get('/api/discovery/stats').then(r => r.data);
}

export function getDiscoveryRuns() {
  return api.get('/api/discovery/runs').then(r => r.data);
}

export function triggerDiscoveryRun({ sourceTier = 'idealo', triggeredBy = 'ui' } = {}) {
  return api.post('/api/discovery/runs', {
    source_tier: sourceTier,
    triggered_by: triggeredBy,
  }).then(r => r.data);
}

// --- Product Suggestions ---

export function suggestProductsForCandidate(id, { limit = 5 } = {}) {
  return api
    .post(`/api/discovery/candidates/${id}/suggest-products`, { limit })
    .then(r => r.data);
}

export function searchProducts(q) {
  if (!q || q.trim().length < 2) return Promise.resolve([]);
  return api
    .get('/api/search/products', { params: { q } })
    .then(r => (Array.isArray(r.data) ? r.data : r.data?.results || []));
}

export function checkCandidateDuplicate(id, sku) {
  return api
    .post(`/api/discovery/candidates/${id}/check-duplicate`, { sku })
    .then(r => r.data);
}

// --- Config ---

export function getDiscoveryConfig() {
  return api.get('/api/discovery/config').then(r => r.data);
}
